import EmblaCarousel from 'embla-carousel';

import { $$ } from '../helpers/shortcuts';
import { matchMedia, media } from '../helpers/media-queries';

const emblaOptions = {
  speed: 7,
};

// Container for handling the autoslide setting
////////////////////////////////////////////////
const autoslideSetting = (function () {
  const KEY = 'autoslide';
  const listeners = [];
  let autosliding = null;

  const updateAutosliding = () => {
    let newAutosliding = browserSetting;
    if (sessionSetting != null) {
      newAutosliding = sessionSetting;
    }

    if (newAutosliding != autosliding) {
      autosliding = newAutosliding;
      for (var cb of listeners) {
        cb(autosliding);
      }
    }
  };

  const setAutosliding = (value) => {
    sessionSetting = !!value;
    localStorage.setItem(KEY, '' + sessionSetting);
    updateAutosliding();
  };

  // Observes browser / system setting
  const prefersReducedMotionMediaQuery = window.matchMedia(
    '(prefers-reduced-motion)',
  );
  let browserSetting = !prefersReducedMotionMediaQuery.matches;
  prefersReducedMotionMediaQuery.addEventListener('change', (ev) => {
    browserSetting = !ev.matches;
    updateAutosliding();
  });

  // Observes session setting
  const parseLocalStorage = (val) => (val == null ? null : val == 'true');
  let sessionSetting = parseLocalStorage(localStorage.getItem(KEY));
  window.addEventListener('storage', (ev) => {
    if (ev.key === KEY || ev.key === null) {
      sessionSetting = parseLocalStorage(ev.newValue);
      updateAutosliding();
    }
  });

  // Initialise state
  updateAutosliding();

  return {
    get: () => autosliding,
    play: () => setAutosliding(true),
    pause: () => setAutosliding(false),
    toggle: () => setAutosliding(!autosliding),
    listen: (cb) => {
      if (!(cb in listeners)) {
        listeners.push(cb);
      }
    },
  };
})();
////////////////////////////////////////////////

function initializeCarousels() {
  initializeHeroSliders();
  initializeFullWidthSliders();
  initializeThemeworldSliders();
  initializeGallerySliders();
  initializeSimpleSliders();
  initializeProductDetailSliders();
  $$('.embla').forEach((wrapper) => {
    let emblaInstance = EmblaCarousel(wrapper, emblaOptions);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
  });
  media('large', () => reinitializeProductSliders());
  media('medium', () => reinitializeProductSliders());
}

function initializeHeroSliders() {
  $$('.heroslider').forEach(($heroslider) => {
    const $wrapper = $heroslider.querySelector('.heroslider-wrapper');
    const options = { ...emblaOptions };
    options.loop = $heroslider.hasAttribute('data-loop');
    const emblaInstance = EmblaCarousel($wrapper, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    if ($heroslider.hasAttribute('data-autoplay')) {
      let autoplayInterval = $heroslider.getAttribute('data-autoplay-interval');
      autoplayInterval = autoplayInterval ? parseInt(autoplayInterval) : 5000;
      const autoplayer = autoplay(emblaInstance, $heroslider, autoplayInterval);
      emblaInstance.on('init', autoplayer.play);
      emblaInstance.on('pointerDown', autoplayer.stop);
      emblaInstance.on('pointerUp', autoplayer.play);
    }
    emblaInstance.on('init', () => {
      renderPagination({
        $sliderNode: $heroslider,
        emblaInstance,
        isAutosliding: true,
      });
    });
  });
}

function initializeProductDetailSliders() {
  $$('.productdetail-image-desktop').forEach(($outerWrapper) => {
    const $slider = $outerWrapper.querySelector(
      '.productdetail-desktoplightbox-slider',
    );
    const options = { ...emblaOptions, align: 'start' };
    options.loop = $slider.hasAttribute('data-loop');
    const emblaInstance = EmblaCarousel($slider, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    const $prevButton = $outerWrapper.querySelector(
      '.productdetail-desktoplightbox-prevbutton',
    );
    const $nextButton = $outerWrapper.querySelector(
      '.productdetail-desktoplightbox-nextbutton',
    );
    if ($prevButton) {
      $prevButton.addEventListener('click', () => {
        emblaInstance.scrollPrev();
      });
    }
    if ($nextButton) {
      $nextButton.addEventListener('click', () => {
        emblaInstance.scrollNext();
      });
    }

    /*
    const $largeImages = $$('.productdetail-desktoplightbox-image');

    emblaInstance.slideNodes().forEach(($slideNode, index) => {
      $slideNode.addEventListener('click', () => {
        $largeImages.forEach(($largeImage, imageIndex) => {
          if (index === imageIndex) {
            $largeImage.classList.add(
              'productdetail-desktoplightbox-iscurrent',
            );
          } else {
            $largeImage.classList.remove(
              'productdetail-desktoplightbox-iscurrent',
            );
          }
        });
      });
    });
    */
  });
}

function initializeSimpleSliders() {
  $$('.simpleslider').forEach(($simpleslider) => {
    const $wrapper = $simpleslider.querySelector('.simpleslider-wrapper');
    const options = { ...emblaOptions };
    options.loop = $simpleslider.hasAttribute('data-loop');
    options.align = $simpleslider.classList.contains('referencebar-slider')
      ? 'start'
      : 'center';
    const emblaInstance = EmblaCarousel($wrapper, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    if ($simpleslider.hasAttribute('data-autoplay')) {
      let autoplayInterval = $simpleslider.getAttribute(
        'data-autoplay-interval',
      );
      autoplayInterval = autoplayInterval ? parseInt(autoplayInterval) : 5000;
      const autoplayer = autoplay(
        emblaInstance,
        $simpleslider,
        autoplayInterval,
      );
      emblaInstance.on('init', autoplayer.play);
      emblaInstance.on('pointerDown', autoplayer.stop);
      emblaInstance.on('pointerUp', autoplayer.play);
    }
    emblaInstance.on('init', () => {
      renderPagination({ $sliderNode: $simpleslider, emblaInstance });
    });
  });
}

function initializeFullWidthSliders() {
  $$('.fullwidthslider').forEach(($fullwidthslider) => {
    const $wrapper = $fullwidthslider.querySelector('.fullwidthslider-wrapper');
    const options = { ...emblaOptions };
    options.loop = $fullwidthslider.hasAttribute('data-loop');
    const emblaInstance = EmblaCarousel($wrapper, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    if ($fullwidthslider.hasAttribute('data-autoplay')) {
      let autoplayInterval = $fullwidthslider.getAttribute(
        'data-autoplay-interval',
      );
      autoplayInterval = autoplayInterval ? parseInt(autoplayInterval) : 5000;
      const autoplayer = autoplay(
        emblaInstance,
        $fullwidthslider,
        autoplayInterval,
      );
      emblaInstance.on('init', autoplayer.play);
      emblaInstance.on('pointerDown', autoplayer.stop);
      emblaInstance.on('pointerUp', autoplayer.play);
    }
    emblaInstance.on('init', () => {
      renderPagination({
        $sliderNode: $fullwidthslider,
        emblaInstance,
        invertedButtons: $fullwidthslider.hasAttribute('data-invertedbuttons'),
      });
    });
  });
}

function initializeThemeworldSliders() {
  $$('.themeworldslider').forEach(($themeworldslider) => {
    const $wrapper = $themeworldslider.querySelector(
      '.themeworldslider-wrapper',
    );
    const options = { ...emblaOptions };
    options.loop = $themeworldslider.hasAttribute('data-loop');
    const emblaInstance = EmblaCarousel($wrapper, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    if ($themeworldslider.hasAttribute('data-autoplay')) {
      let autoplayInterval = $themeworldslider.getAttribute(
        'data-autoplay-interval',
      );
      autoplayInterval = autoplayInterval ? parseInt(autoplayInterval) : 5000;
      const autoplayer = autoplay(
        emblaInstance,
        $themeworldslider,
        autoplayInterval,
      );
      emblaInstance.on('init', autoplayer.play);
      emblaInstance.on('pointerDown', autoplayer.stop);
      emblaInstance.on('pointerUp', autoplayer.play);
    }
    emblaInstance.on('init', () => {
      renderTopPagination({ $sliderNode: $themeworldslider, emblaInstance });
      renderPagination({ $sliderNode: $themeworldslider, emblaInstance });
    });
  });
}

const productSliderEmblaInstances = new WeakMap();
function reinitializeProductSliders() {
  $$('.productslider').forEach(($productslider) => {
    // Figure out how many columns would be visible in the viewport
    let visibleColumns = 1;
    if (matchMedia('medium', { mobileFirst: true })) {
      visibleColumns = 2;
    }
    if (matchMedia('large', { mobileFirst: true })) {
      if ($productslider.classList.contains('productslider-3')) {
        visibleColumns = 3;
      } else {
        visibleColumns = 4;
      }
    }

    const $slides = $productslider.querySelectorAll('.productslider-slide');
    const sliderActive = $slides.length > visibleColumns;

    const $wrapper = $productslider.querySelector('.productslider-wrapper');
    const options = { ...emblaOptions };

    if (sliderActive && !productSliderEmblaInstances.has($productslider)) {
      options.loop = $productslider.hasAttribute('data-loop');
      options.align = 0;
      const emblaInstance = EmblaCarousel($wrapper, options);
      disableInvisibleSlides(emblaInstance);
      improveImageLoadingOnSliding(emblaInstance);
      emblaInstance.on('init', () => {
        renderPagination({ $sliderNode: $productslider, emblaInstance });
      });
      productSliderEmblaInstances.set($productslider, emblaInstance);
    } else if (
      !sliderActive &&
      productSliderEmblaInstances.has($productslider)
    ) {
      productSliderEmblaInstances.get($productslider).destroy();
      productSliderEmblaInstances.delete($productslider);

      const $pagination = $productslider.querySelector('.slider-pagination');
      $pagination.parentElement.removeChild($pagination);
    }
  });
}

function initializeGallerySliders() {
  $$('.galleryslider').forEach(($galleryslider) => {
    const $wrapper = $galleryslider.querySelector('.galleryslider-wrapper');
    const options = { ...emblaOptions };
    options.loop = $galleryslider.hasAttribute('data-loop');
    options.align = 0;
    const emblaInstance = EmblaCarousel($wrapper, options);
    disableInvisibleSlides(emblaInstance);
    improveImageLoadingOnSliding(emblaInstance);
    emblaInstance.on('init', () => {
      renderPagination({ $sliderNode: $galleryslider, emblaInstance });
    });
  });
}

// Autoplay
////////////
function autoplay(embla, rootNode, interval) {
  let timer = 0;
  let playing = false;
  let hasFocus = false;
  let hasMouse = false;

  const shouldBePlaying = () =>
    autoslideSetting.get() && !hasFocus && !hasMouse && playing;

  const updateTimer = () => {
    if (shouldBePlaying() && timer == 0) {
      timer = window.setTimeout(next, interval);
    } else if (timer != 0) {
      window.clearTimeout(timer);
      timer = 0;
    }
  };

  const play = () => {
    playing = true;
    updateTimer();
  };

  const stop = () => {
    playing = false;
    updateTimer();
  };

  autoslideSetting.listen(() => {
    updateTimer();
  });

  const next = () => {
    if (embla.canScrollNext()) {
      embla.scrollNext();
    } else {
      embla.scrollTo(0);
    }
  };

  rootNode.addEventListener('focusin', () => {
    hasFocus = true;
    updateTimer();
  });
  rootNode.addEventListener('focusout', () => {
    hasFocus = false;
    updateTimer();
  });
  rootNode.addEventListener('mouseenter', () => {
    hasMouse = true;
    updateTimer();
  });
  rootNode.addEventListener('mouseleave', () => {
    hasMouse = false;
    updateTimer();
  });

  embla.on('settle', () => {
    if (!shouldBePlaying()) {
      return;
    }
    if (timer != 0) {
      window.clearTimeout(timer);
    }
    timer = window.setTimeout(next, interval);
  });

  return { play, stop };
}
////////////

// A11y
////////
function disableInvisibleSlides(embla) {
  // Beim initialalisieren die Anzahl der gleichzeitig sichtbaren Slides ermitteln
  // Solange händisch gescrollt wird bei jedem Scroll-Event sichtbare Slides aktiv schalten
  // Beim select, settle und pointerUp die auf selectedIndex folgenden Folien aktiv schalten
  embla.on('init', () => {
    const numSlidesInView = embla.slidesInView().length;
    let dragScrolling = false;

    function updateSlidesState(activeSlides) {
      const slides = embla.slideNodes();
      for (const [index, slide] of slides.entries()) {
        if (activeSlides.includes(index)) {
          slide.removeAttribute('aria-hidden');
          slide
            .querySelectorAll('a, button')
            .forEach((el) => el.removeAttribute('tabindex'));
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide
            .querySelectorAll('a, button')
            .forEach((el) => el.setAttribute('tabindex', '-1'));
        }
      }
    }

    // scroll, pointerUp and pointerDown are observed to handle manual dragging
    embla.on('pointerDown', () => (dragScrolling = true));
    embla.on('pointerUp', () => (dragScrolling = false));
    embla.on('scroll', () => {
      if (!dragScrolling) {
        return;
      }
      updateSlidesState(embla.slidesInView());
    });

    // settle is observed to fix accessiible slides when animation ends
    embla.on('settle', () => updateSlidesState(embla.slidesInView()));

    // select is observed to update the accessible slides upon selection
    embla.on('select', () => {
      const selectedIndex = embla.selectedScrollSnap();
      const numSlides = embla.slideNodes().length;
      const upcomingSlidesInView = [];
      for (let i = 0; i < numSlidesInView; ++i) {
        upcomingSlidesInView.push((selectedIndex + i) % numSlides);
      }
      updateSlidesState(upcomingSlidesInView);
    });

    updateSlidesState(embla.slidesInView());
  });
}
////////

// Improve Lazy-Loading when sliding
/////////////////////////////////////
function improveImageLoadingOnSliding(embla) {
  let sliderVisible = false;
  var observer = new IntersectionObserver((entries) => {
    sliderVisible = entries[0].isIntersecting;
  });
  observer.observe(embla.rootNode());

  embla.on('select', () => {
    if (!sliderVisible) {
      return;
    }

    const selectedIndex = embla.selectedScrollSnap();
    const nodes = embla.slideNodes();
    const visibleCount = embla.slidesInView().length;
    for (var i = 0; i < visibleCount; ++i) {
      const node = nodes[(selectedIndex + i) % nodes.length];
      const lazyNodes = node.querySelectorAll('[loading="lazy"]');
      lazyNodes.forEach((lazyNode) => (lazyNode.loading = 'eager'));
    }
  });
}
/////////////////////////////////////

function markCurrentIndicator({
  $indicators,
  currentSlideIndex,
  emblaInstance,
  $nextButton,
  $prevButton,
}) {
  $indicators.forEach(($indicator, index) => {
    if (currentSlideIndex === index) {
      $indicator.classList.add('slider-pagination-iscurrent');
    } else {
      $indicator.classList.remove('slider-pagination-iscurrent');
    }
  });
  $nextButton.disabled = !emblaInstance.canScrollNext();
  $prevButton.disabled = !emblaInstance.canScrollPrev();
}

function renderPagination({
  $sliderNode,
  emblaInstance,
  invertedButtons,
  isAutosliding,
}) {
  const $paginationWrapper = document.createElement('div');
  $paginationWrapper.classList.add('slider-pagination');
  $paginationWrapper.setAttribute('role', 'group');
  $paginationWrapper.setAttribute('aria-label', 'Karussellsteuerung');

  if (isAutosliding) {
    const $toggleButton = document.createElement('button');
    $toggleButton.classList.add(
      'slider-pagination-toggle',
      'button',
      'button-icon',
      'button-icon-largeicon',
      'button-icon-small',
    );
    if (invertedButtons) {
      $toggleButton.classList.add('button-inverted');
    } else {
      $toggleButton.classList.add('button-tertiary');
    }
    $toggleButton.innerHTML = `<i aria-hidden="true"></i>`;
    $toggleButton.addEventListener('click', () => autoslideSetting.toggle());

    const updateToggleButton = (autosliding) => {
      $toggleButton.setAttribute(
        'aria-label',
        autosliding
          ? 'Automatischen Folienwechsel pausieren'
          : 'Automatischen Folienwechsel starten',
      );
      $toggleButton.querySelector('i').className = autosliding
        ? 'ri-pause-circle-line'
        : 'ri-play-circle-line';
    };
    autoslideSetting.listen(updateToggleButton);
    updateToggleButton(autoslideSetting.get());
    $paginationWrapper.appendChild($toggleButton);
  }

  const $indicators = [];
  const $paginationIndicatorWrapper = document.createElement('div');
  $paginationIndicatorWrapper.classList.add('slider-pagination-indicators');

  emblaInstance.slideNodes().forEach((slideEl, index) => {
    const $indicator = document.createElement('button');
    $indicator.classList.add('slider-pagination-indicator');
    $indicator.setAttribute(
      'aria-label',
      `Zeige Folie ${slideEl.dataset.title}`,
    );
    $indicators.push($indicator);
    $paginationIndicatorWrapper.appendChild($indicator);

    $indicator.addEventListener('click', () => emblaInstance.scrollTo(index));
  });

  const $prevButton = document.createElement('button');
  $prevButton.classList.add(
    'slider-pagination-prev',
    'button',
    'button-icon',
    'button-icon-largeicon',
    'button-icon-small',
  );
  if (invertedButtons) {
    $prevButton.classList.add('button-inverted');
  } else {
    $prevButton.classList.add('button-tertiary');
  }
  $prevButton.setAttribute('aria-label', 'Vorherige Folie');
  $prevButton.innerHTML = `<i class="ri-arrow-left-s-line" aria-hidden="true"></i>`;
  $prevButton.addEventListener('click', () => emblaInstance.scrollPrev());

  const $nextButton = document.createElement('button');
  $nextButton.classList.add(
    'slider-pagination-next',
    'button',
    'button-icon',
    'button-icon-largeicon',
    'button-icon-small',
  );
  if (invertedButtons) {
    $nextButton.classList.add('button-inverted');
  } else {
    $nextButton.classList.add('button-tertiary');
  }
  $nextButton.setAttribute('aria-label', 'Nächste Folie');
  $nextButton.innerHTML = `<i class="ri-arrow-right-s-line" aria-hidden="true"></i>`;
  $nextButton.addEventListener('click', () => emblaInstance.scrollNext());

  emblaInstance.on('select', () =>
    markCurrentIndicator({
      $indicators,
      currentSlideIndex: emblaInstance.selectedScrollSnap(),
      emblaInstance,
      $nextButton,
      $prevButton,
    }),
  );
  markCurrentIndicator({
    $indicators,
    currentSlideIndex: emblaInstance.selectedScrollSnap(),
    emblaInstance,
    $nextButton,
    $prevButton,
  });

  $paginationWrapper.appendChild($paginationIndicatorWrapper);
  $paginationWrapper.appendChild($prevButton);
  $paginationWrapper.appendChild($nextButton);
  $sliderNode.prepend($paginationWrapper);
}

function renderTopPagination({ $sliderNode, emblaInstance }) {
  const $paginationWrapper = document.createElement('div');
  $paginationWrapper.classList.add('slider-toppagination');
  $paginationWrapper.setAttribute('role', 'group');
  $paginationWrapper.setAttribute('aria-label', 'Karussellsteuerung');

  const $prevButton = document.createElement('button');
  $prevButton.classList.add(
    'slider-toppagination-prev',
    'button',
    'button-icon',
    'button-icon-largeicon',
    'button-tertiary',
    'button-icon-small',
  );
  $prevButton.setAttribute('aria-label', 'Vorherige Folie');
  $prevButton.innerHTML = `<i class="ri-arrow-left-s-line" aria-hidden="true"></i>`;
  $prevButton.addEventListener('click', () => emblaInstance.scrollPrev());

  const $nextButton = document.createElement('button');
  $nextButton.classList.add(
    'slider-toppagination-next',
    'button',
    'button-icon',
    'button-icon-largeicon',
    'button-tertiary',
    'button-icon-small',
  );
  $nextButton.setAttribute('aria-label', 'Nächste Folie');
  $nextButton.innerHTML = `<i class="ri-arrow-right-s-line" aria-hidden="true"></i>`;
  $nextButton.addEventListener('click', () => emblaInstance.scrollNext());

  const $label = document.createElement('span');
  $label.classList.add('label');

  const initialTitle = emblaInstance.slideNodes()[0].getAttribute('data-title');
  $label.innerHTML = initialTitle && initialTitle.length ? initialTitle : '';

  $paginationWrapper.appendChild($prevButton);
  $paginationWrapper.appendChild($label);
  $paginationWrapper.appendChild($nextButton);
  $sliderNode.prepend($paginationWrapper);

  emblaInstance.on('select', () => {
    const title = emblaInstance
      .slideNodes()
      [emblaInstance.selectedScrollSnap()].getAttribute('data-title');
    $label.innerHTML = title && title.length ? title : '';
  });
}

window.EmblaCarousel = EmblaCarousel;
window.renderPagination = renderPagination;

export { initializeCarousels };
